import { render, staticRenderFns } from "./industryActivityInfo.vue?vue&type=template&id=82e16d44&scoped=true"
import script from "./industryActivityInfo.vue?vue&type=script&lang=js"
export * from "./industryActivityInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e16d44",
  null
  
)

export default component.exports